import React, {useEffect, useState} from 'react';

import {
    ButtonBase,
    Stack, Tab, Tabs,
    Typography,
} from '@mui/material';
import {useQueryClient} from '@tanstack/react-query';

import Icons from 'assets/icons';
import {
    Drawer, HiddenFileInput,
    MenuHeader,
    Text
} from 'components';
import {imageUrl} from 'lib/media';
import {useUserStore} from 'module/user/zustand';
import {useLayoutStore} from 'store';

import Data from './Data';
import Equipment from './Equipment';
// import Settings from './Settings';
import {useApiGet, useApiUpload} from './useUserApi';

const styles = {
    profileLogoHolder: {
        width: '100%',
        position: 'relative',
        paddingTop: '30px',
        paddingBottom: '30px',
        marginBottom: '30px',
        '& img': {
            display: 'block',
            maxWidth: '100%',
            height: 'auto',
            maxHeight: '750px'
        },
    },
    absolutIconBox: {
        position: 'absolute',
        bottom: '0',
        backgroundColor: 'red.highlight',
        borderRadius: '50%',
        height: 60,
        width: 60,
    },
    absolutIconBoxWithoutImage: {
        backgroundColor: 'red.highlight',
        borderRadius: '50%',
        height: 60,
        width: 60,
    },
    uploadButton: {
        backgroundColor: 'red.highlight',
        padding: 1,
        '> svg': {
            fill: theme => theme.palette.white.main,
            width: 18,
            height: 18
        }
    },
    uploadButtonWithoutImage: {
        backgroundColor: 'red.highlight',
        '> svg': {
            fill: theme => theme.palette.white.main,
            width: 30,
            height: 30
        }
    },
    clientHeadline: {
        fontSize: '16px',
        color: 'white.main'
    },

};

const Profile = () => {
    const [tab, setTab] = useState('data');

    const setUser = useUserStore((state) => state.setUser);
    const user = useUserStore((state) => state.user);

    const closeMenu = useLayoutStore(state => state.closeMenu);
    const setShowLoading = useLayoutStore((state) => state.setShowLoading);
    const setShowDrawer = useLayoutStore((state) => state.setShowDrawer);
    const setShowProfile = useLayoutStore((state) => state.setShowProfile);

    const queryClient = useQueryClient();
    const query = useApiGet();
    const userData = query.data;

    const {upload, loading} = useApiUpload();

    const goBack = () => {
        setShowDrawer(true);
        setShowProfile(false);
    };

    const onSave = async (newUser) => {
        newUser.jwt = user.jwt; // preserve JWT
        setUser(newUser);
        await query.refetch();
    };

    const doUpload = async (e) => {
        if (e.target.files.length === 1) {
            const res = await upload(e.target.files[0]);
            e.target.value = null;
            onSave(res);
        }
    };

    useEffect(() => {
        setShowLoading(query.isFetching || loading);
        return () => {
            setShowLoading(false);
        };
    }, [query.isFetching, loading, setShowLoading]);

    useEffect(() => {
        return () => {
            queryClient.removeQueries({queryKey: ['user-get'], exact: true});
        };
    }, [queryClient]);

    console.log(userData);

    return (
        <Drawer open={true} onClose={closeMenu}>
            <MenuHeader text={userData?.username} handleBackButton={goBack} handleClose={closeMenu}/>

            <Stack direction="column" pt={2} alignItems="center">
                
                <Stack sx={styles.profileLogoHolder} justifyContent="center" alignItems="center">
                    {userData?.image && <img src={imageUrl(userData?.image, {w: 300})} alt={userData?.firstname[0] + userData?.lastname[0]} />}
                    <Stack sx={userData?.image ? styles.absolutIconBox : styles.absolutIconBoxWithoutImage} alignItems="center" justifyContent="center">
                        <ButtonBase component="label" sx={userData?.image ? styles.uploadButton : styles.uploadButtonWithoutImage}>
                            <Icons.Camera />
                            <HiddenFileInput name="file" onChange={doUpload}/>
                        </ButtonBase>
                    </Stack>
                </Stack>

                <Stack direction="row" alignItems="center" mb={1}>
                    <Typography sx={styles.clientHeadline}>{userData?.username}</Typography>
                </Stack>
                <Tabs value={tab} onChange={(_e, tab) => setTab(tab)}>
                    <Tab value="data" label={<Text>team.player.data</Text>}/>
                    <Tab value="equipment" label={<Text>user.equipment</Text>}/>
                    {/* <Tab value="settings" label={<Text>global.settings</Text>}/> */}
                </Tabs>
            </Stack>

            <Stack direction="column" justifyContent="space-between">
                {tab === 'data' && userData && <Data user={userData} onSave={onSave}/>}
                {tab === 'equipment' && userData && <Equipment user={userData} onSave={onSave}/>}
                {/* {tab === 'settings' && userData && <Settings user={userData} onSave={onSave}/>} */}
            </Stack>

        </Drawer>
    );
};

export default Profile;